import { ArrowRight, Play } from "lucide-react";

const MANIM_IMG =
  "https://customer-assets.emergentagent.com/job_superate-aprende/artifacts/727651td_image.png";
const S_ICON =
  "https://customer-assets.emergentagent.com/job_superate-aprende/artifacts/jemdy22a_LogoVectorMorado_2.0_SinTexto.svg";

export default function Hero({ onCtaClick }) {
  const scrollToCursos = () => {
    const el = document.getElementById("cursos");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative min-h-[90vh] flex items-center overflow-hidden pt-20 lg:pt-0"
    >
      {/* Background decorative S */}
      <img
        src={S_ICON}
        alt=""
        aria-hidden="true"
        className="absolute right-[-5%] top-[10%] w-[500px] lg:w-[700px] opacity-[0.03] pointer-events-none select-none"
      />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Text */}
          <div className="max-w-2xl">
            <p
              data-testid="hero-overline"
              className="text-sm uppercase tracking-[0.2em] text-[#c77dff] font-semibold mb-6"
            >
              Apoyo universitario de calidad
            </p>

            <h1
              data-testid="hero-title"
              className="text-4xl sm:text-5xl lg:text-[3.5rem] xl:text-6xl font-medium tracking-tight text-white leading-[1.1] mb-6"
            >
              Clases particulares para{" "}
              <span className="text-[#c77dff]">rendir mejor</span> en la
              universidad
            </h1>

            <p
              data-testid="hero-subtitle"
              className="text-base lg:text-lg text-[#a1a1aa] leading-relaxed mb-4 max-w-xl"
            >
              Apoyo en{" "}
              <span className="text-white font-medium">Cálculo</span>,{" "}
              <span className="text-white font-medium">Física</span>,{" "}
              <span className="text-white font-medium">Programación</span> y{" "}
              <span className="text-white font-medium">
                Probabilidades y Estadística
              </span>
              . Material claro, recursos visuales de calidad y explicaciones que
              realmente se entienden.
            </p>

            <p className="text-sm text-[#71717a] mb-8 max-w-xl">
              Clases particulares como servicio principal y cursos asincrónicos
              como complemento flexible para tu ritmo de estudio.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={onCtaClick}
                data-testid="hero-cta-primary"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-lg bg-[#9d4edd] text-white font-medium text-base hover:bg-[#7b2cbf] transition-colors duration-200"
              >
                Quiero clases particulares
                <ArrowRight size={18} />
              </button>
              <button
                onClick={scrollToCursos}
                data-testid="hero-cta-secondary"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-lg border border-white/10 text-white font-medium text-base hover:bg-white/5 transition-colors duration-200"
              >
                <Play size={16} />
                Ver cursos
              </button>
            </div>
          </div>

          {/* Right: Manim visual */}
          <div className="flex justify-center lg:justify-end">
            <div
              data-testid="hero-visual"
              className="relative w-full max-w-md lg:max-w-lg xl:max-w-xl"
            >
              <div className="rounded-2xl overflow-hidden border border-white/10 bg-[#242429]">
                <div className="px-4 py-2.5 border-b border-white/5 flex items-center gap-2">
                  <span className="text-xs text-[#71717a] font-mono">
                    Recurso visual — Derivadas
                  </span>
                </div>
                <img
                  src={MANIM_IMG}
                  alt="Gráfico matemático: función cúbica s(t) = t³ con recta tangente, representando material visual de Supérate"
                  className="w-full h-auto"
                />
              </div>
              <p className="mt-3 text-xs text-[#71717a] text-center">
                Material visual estilo Manim — recursos claros para cada tema
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
